export default "__VITE_ASSET__junBVcFq__"